import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link, NavLink } from 'react-router-dom';

const Navigation: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <Navbar variant="dark" expand="lg" className="mb-4 atn-navbar">
      <Container fluid>
        <Navbar.Brand as={Link} to="/dashboard" className="d-flex align-items-center gap-2">
          <div style={{
            background: 'white',
            padding: '0.4rem 0.8rem',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}>
            <img
              src="/logo.png"
              alt="ATN Instruments"
              height={32}
              style={{ display: 'block' }}
              onError={(e) => {
                // Fallback to text if logo is not found yet
                (e.currentTarget as HTMLImageElement).style.display = 'none';
              }}
            />
          </div>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/dashboard">
              Dashboard
            </Nav.Link>
            
            {user.role === 'superadmin' && (
              <Nav.Link as={NavLink} to="/customers">
                Customers
              </Nav.Link>
            )}
            
            {/* Users: visible to superadmin and customers */}
            {(user.role === 'superadmin' || user.role === 'customer') && (
              <Nav.Link as={NavLink} to="/users">
                Users
              </Nav.Link>
            )}
            
            {/* Gateways: visible to superadmin only */}
            {user.role === 'superadmin' && (
              <Nav.Link as={NavLink} to="/gateways">
                Gateways
              </Nav.Link>
            )}
            
            {/* Systems: visible to Customers and Users (users see assigned systems) */}
            {(user.role === 'customer' || user.role === 'user') && (
              <Nav.Link as={NavLink} to="/systems">
                Systems
              </Nav.Link>
            )}
            {/* Products: keep visible to Super Admin only */}
            {user.role === 'superadmin' && (
              <Nav.Link as={NavLink} to="/products">
                Products
              </Nav.Link>
            )}
          </Nav>
          
          <Nav>
            <NavDropdown 
              title={`${user.name} (${user.role})`} 
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.Item as={Link} to="/profile">
                Profile
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/change-password">
                Change Password
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;